import * as React from 'react';
import Button from '@mui/material/Button';
import { Grid } from '@material-ui/core';
import styles from "./team.module.css";
import { styled } from '@mui/material/styles';

/* Teams page is dark via :root CSS variables; MUI theme mode may still be "light". */
const InputWrapper = styled('div')(
    () => `
  width: 300px;
  border: 1px solid var(--primary-theme-color);
  background-color: var(--primary-popup-background-color);
  border-radius: 6px;
  padding: 1px 4px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  box-sizing: border-box;

  &:hover {
    border-color: var(--primary-theme-color);
  }

  &.focused {
    border-color: var(--primary-theme-color);
    box-shadow: 0 0 0 1px var(--primary-theme-color);
  }

  & input {
    background-color: transparent;
    color: var(--primary-text-color);
    height: 30px;
    box-sizing: border-box;
    padding: 4px 6px;
    width: 0;
    min-width: 30px;
    flex-grow: 1;
    border: 0;
    margin: 0;
    outline: 0;
    font-family: Poppins, sans-serif;
    font-size: 14px;
  }

  & input::placeholder {
    color: var(--primary-text-color-80);
    opacity: 1;
  }
`,
);

const Root = styled('div')(
    () => `
  color: var(--primary-text-color);
  font-size: 14px;
`,
);

export default function BasicModal(props) {
    const { setSearchValue, searchValue, loadAllpayersData } = props

    return (
        <div className={styles.formHeadTop}>
            <Grid container style={{
                width: "76%",
                height: "2.3rem"
            }} justifyContent="flex-end">
                <Root>
                    <InputWrapper>
                        <i
                            className="fa fa-search"
                            style={{
                                margin: '0.5rem 0.2rem 0.5rem 0.5rem',
                                color: 'var(--primary-theme-color)',
                            }}
                        ></i>
                        <input placeholder={'Search by name'} onChange={(e) => setSearchValue(e.target.value)} />
                    </InputWrapper>
                </Root>
                <Button
                    fullWidth
                    size='large'
                    disabled={searchValue?.length === 0}
                    style={searchValue?.length > 0 ? {
                        fontSize: '0.8rem',
                        lineHeight: '1rem',
                        fontFamily: 'Poppins',
                        fontWeight: 500,
                        fontStyle: 'normal',
                        width: 80,
                        height: 32,
                        marginLeft: "0.5rem",
                        backgroundColor: "var(--primary-theme-color)",
                        color: "var(--primary-button-text-color)",
                        textTransform: "capitalize",
                    } : {
                        fontSize: '0.8rem',
                        lineHeight: '1rem',
                        fontFamily: 'Poppins',
                        fontWeight: 500,
                        fontStyle: 'normal',
                        width: 80,
                        height: 32,
                        marginLeft: "0.5rem",
                        backgroundColor: "var(--primary-button-disabled-background-color)",
                        color: "var(--primary-button-disabled-text-color)",
                        textTransform: "capitalize",
                    }}
                    onClick={() => loadAllpayersData()}
                >
                    Search
                </Button>
            </Grid>
        </div>
    );
}